import React, { useCallback, useState } from 'react';
import { shelf as c } from '../../component-classes';
import { Carousel } from '../carousel/Carousel';

const MAGIC_NUMBER = 32;

type CategoriesShelfProps = React.PropsWithChildren<{
    className?: string;
    heading: string;
    wrapRows?: boolean;
}>;

function CategoriesShelf(props: CategoriesShelfProps) {
    const { children, className, heading, wrapRows = false } = props;

    const [initialWidth, setInitialWidth] = useState(0);

    const listRef = useCallback((callbackElement: HTMLUListElement) => {
        if (callbackElement !== null) {
            setInitialWidth(callbackElement.scrollWidth);
        }
    }, []);

    const wrapWidthStyle: any = {};
    if (wrapRows && initialWidth) {
        const wrapWidth = Math.ceil(initialWidth / 2 + MAGIC_NUMBER);
        wrapWidthStyle['--sf-shelf-wrap-width'] = `${wrapWidth}px`;
    } else {
        wrapWidthStyle['--sf-shelf-wrap-width'] = 'max-content';
    }

    const childCount = React.Children.count(children);
    const isLastChild = (index: number) => index === childCount - 1;

    return (
        <section className={className}>
            <div className={c.header}>
                <h2 className={c.title}>{heading}</h2>
            </div>
            <div className={c.fade}>
                <Carousel as="div" bleed>
                    <ul
                        ref={listRef}
                        className="sf-shelf-wrap-rows -mb-8"
                        style={wrapWidthStyle}
                    >
                        {React.Children.map(children, (child, index) => {
                            const itemClass = `flex-shrink-0 mr-8 mb-8 ${
                                isLastChild(index) ? 'pr-16' : ''
                            }`;
                            return <li className={itemClass}>{child}</li>;
                        })}
                    </ul>
                </Carousel>
            </div>
        </section>
    );
}

export default CategoriesShelf;
